export const DEFAULT_PLACEHOLDER = "Select an option";
export const SEARCH_PLACEHOLDER = "Search";
export const DEFAULT_NO_OPTIONS_TEXT = "No options";
export const DEFAULT_CREATE_LABEL = "New Data";
